import { z } from 'zod';

export const configSettingSchema = z.object({
  settingId: z.number(),
  settingName: z.string().min(1),
});

export const configSettingsSchema = z.array(configSettingSchema);

export type ConfigSetting = z.infer<typeof configSettingSchema>;

export type ConfigSettings = z.infer<typeof configSettingsSchema>;
